import {
  V2_CLIENT_FORGOT_PASSWORD,
  V2_CLIENT_FORGOT_PASSWORD_SUCCESS,
  V2_CLIENT_FORGOT_PASSWORD_ERROR,
  V2_CLIENT_FORGOT_PASSWORD_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const V2ClientForgotPassword = (state = initialState, action) => {
  switch (action.type) {
    case V2_CLIENT_FORGOT_PASSWORD:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case V2_CLIENT_FORGOT_PASSWORD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case V2_CLIENT_FORGOT_PASSWORD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case V2_CLIENT_FORGOT_PASSWORD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default V2ClientForgotPassword;
